// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eight-team-bracketlive {
  display: flex;
  flex-direction: row;
  padding: 24px;
  max-width: 100%;
  width: 100%;
  overflow: scroll;
  margin: 0 auto;
}

.eight-team-bracketlive-column {
  display: flex;
  flex-direction: column;
}

.eight-team-bracketlive-column-games-first {
  margin-left: 24px;
}

.eight-team-bracketlive-column-games-second {
  margin-top: 0px;
}

.eight-team-bracketlive-column-games-third {
  margin-top: 0px;
}

.eight-team-bracketlive-column-games-final {
  margin-top: 0px;
}

.eight-team-bracketlive-column-games-champ {
  margin-top: 0px;
  margin-left: 84px;
}

.eight-team-bracketlive-game-spacer {
  margin-bottom: 48px;
}

.eight-team-bracketlive-game-spacer-two {
  margin-bottom: 32px;
}

.eight-team-bracketlive-game-spacer-large {
  margin-bottom: 113px;
}

.eight-team-bracketlive-connector {
  border-color: #002129;
  border-style: solid;
  width: 42px;
}

.eight-team-bracketlive-connector-first {
  height: 203px;
  border-top-width: 1px;
  border-bottom-width: 1px;
  margin-top: 180px;
}

.eight-team-bracketlive-connector-first-two {
  height: 203px;
  border-top-width: 1px;
  border-bottom-width: 1px;
  margin-top: 201px;
}

.eight-team-bracketlive-connector-second {
  height: 222px;
  margin-top: 173.5px;
  border-top-width: 1px;
  border-bottom-width: 1px;
  border-right-width: 1px;
}
.eight-team-bracketlive-connector-second + .eight-team-bracketlive-connector-second {
  margin-top: 177px;
}

.eight-team-bracketlive-connector-third {
  height: 402px;
  margin-top: 281.5px;
  border-top-width: 1px;
  border-bottom-width: 1px;
}

.eight-team-bracketlive-connector-third-right {
  border-right-width: 1px;
}

.eight-team-bracketlive-connector-final {
  height: 1px;
  margin-top: 482.5px;
  border-top-width: 1px;
}`, "",{"version":3,"sources":["webpack://./src/components/Brackets/EightTeamBracket/EightTeamBracketLive.scss"],"names":[],"mappings":"AACA;EACI,aAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;AAAJ;;AAGE;EACE,aAAA;EACA,sBAAA;AAAJ;;AAGE;EACE,iBAAA;AAAJ;;AAGE;EACE,eAAA;AAAJ;;AAGE;EACE,eAAA;AAAJ;;AAGE;EACE,eAAA;AAAJ;;AAGE;EACE,eAAA;EACA,iBAAA;AAAJ;;AAGE;EACE,mBAAA;AAAJ;;AAGE;EACE,mBAAA;AAAJ;;AAGE;EACE,oBAAA;AAAJ;;AAGE;EACE,qBAAA;EACA,mBAAA;EACA,WAAA;AAAJ;;AAGE;EACE,aAAA;EACA,qBAAA;EACA,wBAAA;EACA,iBAAA;AAAJ;;AAIE;EACE,aAAA;EACA,qBAAA;EACA,wBAAA;EACA,iBAAA;AADJ;;AAKE;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,wBAAA;EACA,uBAAA;AAFJ;AAII;EACE,iBAAA;AAFN;;AAME;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,wBAAA;AAHJ;;AAME;EACE,uBAAA;AAHJ;;AAME;EACE,WAAA;EACA,mBAAA;EACA,qBAAA;AAHJ","sourcesContent":["// styles/bracket.scss\n.eight-team-bracketlive {\n    display: flex;\n    flex-direction: row;\n    padding: 24px;\n    max-width: 100%;\n    width: 100%;\n    overflow: scroll;\n    margin: 0 auto;\n  }\n  \n  .eight-team-bracketlive-column {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .eight-team-bracketlive-column-games-first {\n    margin-left: 24px;\n  }\n  \n  .eight-team-bracketlive-column-games-second {\n    margin-top: 0px;\n  }\n  \n  .eight-team-bracketlive-column-games-third {\n    margin-top: 0px;\n  }\n  \n  .eight-team-bracketlive-column-games-final {\n    margin-top: 0px;\n  }\n\n  .eight-team-bracketlive-column-games-champ {\n    margin-top: 0px;\n    margin-left: 84px;\n  }\n  \n  .eight-team-bracketlive-game-spacer {\n    margin-bottom: 48px;\n  }\n\n  .eight-team-bracketlive-game-spacer-two {\n    margin-bottom: 32px\n    }\n  \n  .eight-team-bracketlive-game-spacer-large {\n    margin-bottom: 113px;\n  }\n  \n  .eight-team-bracketlive-connector {\n    border-color: #002129;\n    border-style: solid;\n    width: 42px;\n  }\n  \n  .eight-team-bracketlive-connector-first {\n    height: 203px;\n    border-top-width: 1px;\n    border-bottom-width: 1px;\n    margin-top: 180px;\n    \n  }\n\n  .eight-team-bracketlive-connector-first-two {\n    height: 203px;\n    border-top-width: 1px;\n    border-bottom-width: 1px;\n    margin-top: 201px;\n    \n  }\n  \n  .eight-team-bracketlive-connector-second {\n    height: 222px;\n    margin-top: 173.5px;\n    border-top-width: 1px;\n    border-bottom-width: 1px;\n    border-right-width: 1px;\n  \n    & + & {\n      margin-top: 177px;\n    }\n  }\n  \n  .eight-team-bracketlive-connector-third {\n    height: 402px;\n    margin-top: 281.5px;\n    border-top-width: 1px;\n    border-bottom-width: 1px;\n  }\n  \n  .eight-team-bracketlive-connector-third-right {\n    border-right-width: 1px;\n  }\n  \n  .eight-team-bracketlive-connector-final {\n    height: 1px;\n    margin-top: 482.5px;\n    border-top-width: 1px;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
